export enum EProductContainer {
	PIECES = 'pieces',
	PALLETS = 'pallets',
	CONTAINERS = 'containers',
}

export enum EFileModelType {
	NEWS = 'news',
	CMS_LOCATION_CONTENT = 'CMSLocationContent',
	SUBPAGE_CONTENT = 'SubpageContent',
	CONTENT_SECTION = 'ContentSection',
}

export enum EFileCollection {
	PRODUCT_IMAGE = 'product_image',
	PRODUCT_ATTACHMENT = 'product_attachment',
	NEGOTIATION_PROFORMA = 'negotiation_proforma',
	NEGOTIATION_INVOICE = 'negotiation_invoice',
	NEGOTIATION_ATTACHMENT = 'negotiation_attachment',
	NEGOTIATION_CONFIRMATION = 'negotiation_confirmation',
	NEGOTIATION_PAY_CONFIRMATION = 'negotiation_payment_confirmation',
	NEWS_TOP_IMAGE = 'news_top_image',
	NEWS_BOTTOM_IMAGE = 'news_bottom_image',
	NEWS_CONTENT_IMAGE = 'news_content_image',
	PARAGRAPH_HEADER_IMAGE = 'paragraph_header_image',
	PAGE_HEADER_IMAGE = 'page_header_image',
	CMS_LOCATION_CONTENT_IMAGE = 'cms_location_content_image',
	SUBPAGE_CONTENT_IMAGE = 'subpage_content_image',
	MAIN_PAGE_CONTENT_IMAGE = 'main_page_content_image',
	STRUCTURAL_DATA_IMAGE = 'structural_data_image',
}

export enum EProductStatus {
	PUBLIC = 'public',
	USER_PENDING = 'user_pending',
	USER_ACCEPTED = 'user_accepted',
	USER_REJECTED = 'user_rejected',
	ARCHIVED = 'archived',
}

export enum EProductTab {
	ALL = 'all',
	ACTIVE = 'active',
	TO_BE_ACCEPTED = 'to be accepted',
	ARCHIVED = 'archived',
}
